import type {Logger} from 'core/logging/types';
import {isInterruptedActionResponse} from 'src/modals/modal-utils';


export function setupGlobalErrorLogging(logger: Logger): void {
    window.addEventListener('error', (event) => {
        if (isInterruptedActionResponse(event.error)) {
            return;
        }
        logger.error('[Unhandled error]', event.message, event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
        if (isInterruptedActionResponse(event.reason)) {
            return;
        }
        logger.error('[Unhandled rejection]', event.type, event.reason);
    });
}